import React from 'react';
import './agreement.scss';

const Agreement = () => {
  return (
    <div className="agreement_page">
      <div className="agreement_main">
        <div className="text-align-center">
          <h3>隐私政策</h3>
        </div>
        <p>欢迎您使用优点调度APP，优点调度APP是滴滴优点科技（深圳）有限公司开发并运营。</p>
        <p>
          我们深知个人信息对您的重要性。我们将按照法律法规的要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。在使用优点调度APP产品或服务前，请您务必仔细阅读并透彻理解本政策。如对本政策内容有任何疑问、意见或建议，您可通过优点调度APP提供的各种联系方式与我们联系。
          优点调度的用户隐私保护声明目录如下：
        </p>
        <h4>一、 位置信息：</h4>
        <p>
          在您使用优点调度APP部分功能前，我们会提示您选择是否允许优点调度APP获取您的位置信息。在您使用优点调度APP的过程中，您可以随时通过您的设备设置功能，停止我们对您的地址位置信息的收集，之后您可能将无法使用上述基于位置信息提供的相关服务或功能，或者无法达到上述基于位置信息提供的相关服务拟达到的效果，但不会影响您正常使用“优点调度”的其他业务功能。
        </p>
        <h4>二、 日志信息：</h4>
        <p>
          与大多数互联网服务一样，当您使用“优点调度”移动应用的各项服务时，我们的服务器会自动记录您的日志信息，例如您点击的链接、您的浏览记录等。您访问服务的日期、时间、时长等您在使用我们的产品或服务时形成的信息。为了向您提供更准确的定制化信息，我们会对您的搜索历史等您在使用我们的产品或服务时提供、形成或留存信息进行保存。
        </p>
        <h4>三、变更：</h4>
        <p>我们的的隐私政策可能变更。</p>
        <p>
          未经您明确同意，我们不会削减您按照本隐私政策所应享有的权力。我们会在本页面上发布本隐私政策所做的任何变更。若您不同意该变更，请您立即停止使用“优点调度”移动应用产品和服务。
        </p>
      </div>
      <div className="footer">Copyright © 2019 滴滴优点科技（深圳）有限公司</div>
    </div>
  );
};

export default Agreement;



// WEBPACK FOOTER //
// ./src/view/home/ud_privacy.js